import { lowerCase } from "lodash";
import { AppConstants } from "../constants/AppConstants";

export const formatDate = (date: any) => {
  return new Date(date).toISOString().split("T")[0];
};

export const formatPhoneNumber = (value: any) => {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength < 4) return `${phoneNumber}`;

  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }

  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(
    3,
    6
  )}-${phoneNumber.slice(6, 10)}`;
};

export const getCountryCodeViaLocale = (locale: string) => {
  let country = lowerCase(locale.split("-")[1]);
  if (country.length) {
    localStorage.setItem(AppConstants.LOCAL_STORAGE_COUNTRY_KEY, country);
  }
};
